import HashtagPosts from './hashtag-posts';

export default HashtagPosts;